<template>
    <div>
        <p class="timeline-talks" v-html="message"></p>
        <div class="timeline-component">
            <p v-if="details.purposeOfProcessing" ><strong>Purpose of Processing : </strong>{{details.purposeOfProcessing}}</p>
            <p v-if="details.userId" ><strong> Action By : </strong>{{details.user.firstName}} {{details.user.lastName}} ({{details.user.role.title}})</p>
            <p v-else ><strong> Action By : </strong>Idenfo System</p>
            <p v-if="details.legalBasisForProcessing" ><strong>Legal Basis for Processing : </strong>{{details.legalBasisForProcessing}}</p>
            <p v-if="details.retentionPeriod" ><strong>Retention Period : </strong>{{details.retentionPeriod}}</p>
        </div>
    </div>
</template>

<script>
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: ['details'],
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {}
    },
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        message() {
            if (this.details.currentObj.riskLevel) {
                return (
                    'Manual alert has been created with override risk rating to ' +
                    this.details.currentObj.riskLevel +
                    ' Risk with the following comment,<br>' +
                    this.details.currentObj.comments
                )
            }
            return 'Manual alert has been created with override risk rating to High Risk with the following comment.'
        },
    },
}
</script>
